// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addparts_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}

.Addpartsmain {
  width: 100%;
  background: #ffffff;
  overflow-y: scroll;
  overflow-x: hidden;
  height: 90vh;
}

.Edit_new_part_text {
  display: flex;
  justify-content: space-between;
  width: 96%;
  margin: 1rem;
}

.Edit_new_part_text > span {
  font-family: Nunito;
  font-size: 20px;
  font-weight: 600;
  color: #10132E;
}

.Edit_new_part_text > button {
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: white;
  border-radius: 5px;
  width: 8%;
}
.Edit_new_part_text > button .AddPartsontainers {
  height: auto;
}
.Edit_new_part_text > button .AddPartsontainers .Edit_new_part_text > button {
  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);
  font-family: Nunito;
  font-size: 16px;
  font-weight: 700;
  color: white;
  border-radius: 5px;
  width: 8%;
}
@media screen and (max-width: 748px) {
  .Edit_new_part_text > button .addparts_container {
    flex-direction: column;
  }
  .Edit_new_part_text > button .Addpartsmain {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/EditParts/addparts.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AACF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,YAAA;AAEF;;AAAA;EACE,mBAAA;EACF,eAAA;EACA,gBAAA;EACA,cAAA;AAGA;;AAAA;EACE,mEAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AAGF;AAFA;EACE,YAAA;AAIF;AAFE;EACE,mEAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AAIJ;AAAA;EACE;IACE,sBAAA;EAEF;EACA;IACE,WAAA;EACF;AACF","sourcesContent":[".addparts_container {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n}\n\n.Addpartsmain {\n  width: 100%;\n  background: #ffffff;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  height: 90vh;\n}\n.Edit_new_part_text{\n  display: flex;\n  justify-content: space-between;\n  width: 96%;\n  margin: 1rem;\n}\n.Edit_new_part_text >span{\n  font-family: Nunito;\nfont-size: 20px;\nfont-weight: 600;\ncolor: #10132E;\n\n}\n.Edit_new_part_text  > button{\n  background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 700;\n  color: white;\n  border-radius: 5px;\n  width: 8%;\n.AddPartsontainers {\n  height: auto;\n\n  .Edit_new_part_text >button {\n    background: linear-gradient(277.62deg, #0C3688 10%, #2057C2 84.88%);\n    font-family: Nunito;\n    font-size: 16px;\n    font-weight: 700;\n    color: white;\n    border-radius: 5px;\n    width: 8%;\n  }\n}\n\n@media screen and (max-width:748px) {\n  .addparts_container {\n    flex-direction: column;\n  }\n\n  .Addpartsmain {\n    width: 100%;\n  }\n}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
